import extend from '@/utils/vuex-extend';
import {base} from "@/vuex-extend";
import moment from "moment";

const today = moment().format('L')
export default extend(base, {
	namespaced: true,
	state: {
		searchForm: {
			time: [`${today} 00:00:00`, `${today} 23:59:59`]
		},
		type: 0
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/scm/receivable/index.js